// To change portfolio colors globally go to the _globalColor.scss file


import splashImage from "./assets/images/me.png"; // Import static image

import awsLogoImg from "./assets/images/awslogoo.png";
import databricksImg from "./assets/images/databricks.png";
import awsCommunityBuilderImg from "./assets/images/awscommunitybuilder.png";
import leapfrogLogo from "./assets/images/leapfroglogo.png";
import quicargoLogo from "./assets/images/quicargo.png";
import laudioLogo from "./assets/images/laudiologo.png";
import returnalyzeLogo from "./assets/images/returnalyze.png";
import katzLogo from "./assets/images/katz.png";
import modyLogo from "./assets/images/mody.png";

// Gallery images - using static paths

// Splash Screen
const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashImage, // Static image as splash screen
  duration: 2000, // Set duration as per your preference
};
// Summary And Greeting Section
const illustration = {
  animated: false, // Set to false to use static SVG
};

const greeting = {
  username: "Niyanta Pandey",
  title: "Hi all, I'm Niyanta",
  subTitle: "Data Engineer | Cloud Enthusiast | AI Explorer - Ready to explore data's next frontier? Let's connect!",
  resumeLink: "", // Set to empty to hide the button
  displayGreeting: true, // Set false to hide this section, defaults to true
  displayImage: true, // Add this to control image visibility
};

// Open Source Section
const projects = {
  display: true, // Set to true to display the GitHub projects section
};


// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/Niyanta5",
  linkedin: "https://www.linkedin.com/in/niyantapandey/",
  gmail: "niyantapandey@gmail.com",
  display: true, // Set true to display this section, defaults to false
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    // your existing skills array
  ],
  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    // Add more skills as needed
  ],
  display: true
};

const educationInfo = {
  display: true,
  title: "Academic Background",
  subtitle: "",
  schools: [
    {
      schoolName: "Yeshiva University, New York",
      logo: katzLogo,
      subHeader: "Master of Science in Data Analytics and Visualization",
      location: "New York, NY, USA",
      duration: "Sep 2023 – May 2025",
      desc: "Focus: Data Science and Cloud Computing",
      gpa: "GPA: 3.77 / 4.0",
      projects: [
        {
          name: "Generative AI Capstone Project",
          logo: katzLogo,
          date: "Jan 2025 – May 2025",
          description:
            "Graduate capstone project focused on building a Generative AI chatbot using Retrieval-Augmented Generation (RAG) to enable natural language access to complex internal documents.",
          descBullets: [
            "Designed and implemented backend RAG pipeline using LangChain and Azure OpenAI for intelligent Q&A over enterprise documents",
            "Integrated Azure Blob Storage, Cognitive Search, and Azure Functions for semantic search and scalable document ingestion",
            "Applied advanced embedding strategies and prompt engineering to improve chatbot relevance and response quality",
            "Collaborated closely with frontend team for seamless integration of the AI engine into a user-facing interface"
          ]
        }
      ]
    },
    {
      schoolName: "Mody University of Science and Technology, India",
      logo: modyLogo,
      subHeader: "Bachelor of Technology in Electronics and Communication Engineering",
      location: "Lakshmangarh, Rajasthan, India",
      duration: "Sep 2014 – May 2018",
      desc: "Focus: Statistics, Computer Networks, and Digital Electronics",
      projects: [
        {
          name: "EEG Signal Classification",
          date: "Jan 2018 – May 2018",
          description:
            "Automated classification of EEG signals using Support Vector Machine (SVM) to identify neurological patterns. Achieved high accuracy rate of 88% and demonstrated machine learning feasibility in medical diagnostics."
        }
      ]
    }
  ]
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Data Engineer / Analyst",
      company: "Leapfrog Technology",
      companylogo: leapfrogLogo,
      date: "Jan 2019 – Sep 2021",
      description:
        "Collaborated with engineering managers and cross-functional teams to optimize data workflows, mentored junior engineers, and improved data reliability.",
      descBullets: [
        "Architected automated data quality frameworks for healthcare and retail clients, ensuring high data accuracy",
        "Worked with engineering managers to define project timelines, prioritize tasks, and drive successful pipeline implementations",
        "Mentored junior engineers, supporting their development and growth within the data engineering field",
        "Collaborated with product teams to design and implement data engineering solutions that streamlined workflows",
        "Optimized AWS Redshift and SQL queries, resulting in a 30% improvement in data retrieval efficiency"
      ],
      projects: [
        {
          name: "Laudio",
          logo: laudioLogo,
          date: "Feb 2019 – Sep 2020",
          description:
            "Automated end-to-end data quality frameworks using SQL. Leveraged AWS tools (S3, Lambda, Airflow) and Mixpanel to ensure reliable healthcare staff engagement data."
        },
        {
          name: "Returnalyze",
          logo: returnalyzeLogo,
          date: "Sep 2020 – Mar 2021",
          description:
            "Collaborated with clients to define project requirements, optimized data workflows, and assisted with new client onboarding processes."
        }
      ]
    },
    {
      role: "Data Engineer",
      company: "Quicargo (Formerly Redistri)",
      companylogo: quicargoLogo,
      date: "Sep 2021 – Aug 2023",
      description:
        "Led data infrastructure modernization efforts and streamlined logistics workflows with scalable data solutions.",
      descBullets: [
        "Built scalable data platforms using FastAPI, SQLAlchemy, and PostgreSQL for logistics data insights",
        "Migrated core services to AWS (EC2, EKS, S3), improving scalability and reducing infrastructure costs",
        "Engineered real-time data pipelines with Apache Kafka to support high-speed data streaming and processing"
      ]
    }
  ]
};




// Certifications Section
const achievementSection = {
  display: true, // Ensure this is true
  title: "Certifications & Recognitions",
  subtitle: "Validations of my continuous learning and community contributions",
  achievementsCards: [
    {
      title: "AWS Academy Certifications",
      subtitle: "Earned multiple AWS certifications",
      image: awsLogoImg,
      imageAlt: "AWS logo",
      footerLink: [
        {
          name: "Cloud Foundations",
          url: "https://www.credly.com/badges/ee5b8748-f1ec-449d-be3a-5899dc82ffc3/linked_in?t=sktkrv"
        },
        {
          name: "Cloud Architect",
          url: "https://www.credly.com/badges/5e3ed7e4-4dc6-4565-ba1f-fc1416cd1989/linked_in_profile"
        },
        {
          name: "Data Engineer",
          url: "https://www.credly.com/badges/d10ea2d7-9896-4c7d-ae32-8670f8b318f3/linked_in_profile"
        }
      ]
    },

    {
      title: "Databricks Fundamentals",
      subtitle: "Academy Accreditation - Databricks",
      image: databricksImg,
      imageAlt: "Databricks",
      footerLink: [
        {
          name: "Credential",
          url: "https://credentials.databricks.com/a23002ca-7b0b-46db-b094-aa01c5bfd7f3#acc.PTs4MDJk"
        }
      ]
    },
    {
      title: "AWS Community Builder",
      subtitle: "Selected for contributions to the data category (2025)",
      image: awsCommunityBuilderImg,
      imageAlt: "AWS Community Builder Badge",
      footerLink: [
        {
          name: "Details",
          url: "https://www.linkedin.com/feed/update/urn:li:activity:7303663947520376832/"
        }
      ]
    },
  ]
};




// Blogs Section
const blogSection = {
  title: "Blogs",
  subtitle: "I like sharing what I have learnt",
  display: true,
  blogs: [
    {
      url: "https://substack.com/@niyantaa/note/c-105448352",
      title: "Weights, Biases and Activation Functions Explained",
      description: "Neural Networks Unveiled — Part 1/5"
    },
    {
      url: "https://substack.com/home/post/p-160560676",
      title: "Loss functions, backpropagation, and Gradient Descent Explained",
      description: "Neural Networks Unveiled — Part 2/5"
    },
    {
      url: "https://substack.com/@niyantaa/note/p-160798155",
      title: "Building a Neural Network from Ground Up with Breast Cancer Dataset",
      description: "Neural Networks Unveiled — Part 3/5"
    }
  ]
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: false, // Set false to hide this section, defaults to true
};

// Contact Section
const contactInfo = {
  title: "Contact Me",
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "niyantapandey@gmail.com",
};

// Gallery Section
const gallerySection = {
  title: "Gallery",
  subtitle: "A glimpse into my world through images",
  display: true,
  images: [
    {
      src: "/images/pic1.png",
      alt: "Gallery Image 1"
    },
    {
      src: "/images/pic2.png",
      alt: "Gallery Image 2"
    },
    {
      src: "/images/pic3.png",
      alt: "Gallery Image 3"
    },
    {
      src: "/images/pic4.png",
      alt: "Gallery Image 4"
    },
    {
      src: "/images/pic5.png",
      alt: "Gallery Image 5"
    }
  ]
};

// Twitter Section
const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false, // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be displayed as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  workExperiences,
  projects,
  achievementSection,
  blogSection, // Make sure this line exists
  gallerySection,
  resumeSection,
  contactInfo,
  twitterDetails,
  isHireable
};
